import styled from 'styled-components';

import { PurchaseButton } from '../Header/styles';

export const Container = styled.div`
	margin-bottom: 200px;
`;

export const BuyBox = styled.div`
	text-align: center;
`;
export const BuyButton = styled(PurchaseButton)`
	float: none !important;
`;
